export const AssessmentCalc = ({ value, record }) => value == null ? '' : ((!!value) ? 'Ja' : 'Nein');
